
var EventEmitter = require('eventemitter3'),
	events = new EventEmitter()

export default events